/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import type { Listable, Pin, Property } from '@zcode/state-type'
import * as SourceC from '../../../../shared/constants/source'

export const isShortTermFeed = (t: Listable | Pin | Property) =>
  t?.feedName === SourceC.BOOKINGDOTCOM ||
  t?.feedName === SourceC.NESTPICK ||
  t?.feedName === SourceC.NESTPICK_HIGH ||
  t?.feedName === SourceC.RENTALS_UNITED ||
  t?.feedName === SourceC.VRBO
